module.exports = __webpack_public_path__ + "static/img/product_images_05_h5_zh.c21bc2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_05_h5_zh.png
// module id = D35+
// module chunks = 34